import { createAction } from 'redux-actions';

export const auctionBidResetMaster = createAction('AUCTION_BID_RESET_MASTER');
export const auctionDetailResetMaster = createAction(
  'AUCTION_DETAIL_RESET_MASTER'
);
